if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			
			// Remove any existing alerts
			this.querySelectorAll('.alert').forEach(alertEl => {
				alertEl.remove();
			});

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					// Update header cart counts and totals
					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});
					
					// Update shipping progress component with new cart total
					try {
						const shippingProgress = document.querySelector('shipping-progress');
						if (shippingProgress) {
							const cartTotalElement = cartItems.querySelector('[data-cart-total]');
							if (cartTotalElement) {
								// Extract numeric value from money format (e.g., "€32,50" -> 3250)
								const cartTotalText = cartTotalElement.textContent;
								// Remove currency symbols and convert European format to standard
								const numericValue = cartTotalText
									.replace(/[€$£]/g, '') // Remove currency symbols
									.replace(/\./g, '') // Remove thousands separators (dots in European format)
									.replace(',', '.'); // Replace comma with dot for decimal
								const cartTotal = Math.round(parseFloat(numericValue) * 100);
								console.log('Cart quantity update - parsed values:', {
									originalText: cartTotalText,
									numericValue: numericValue,
									cartTotal: cartTotal
								});
								// Update shipping progress directly with the cart total
								shippingProgress.updateCartTotal(cartTotal);
							}
						}
					} catch (error) {
						console.log('Error updating shipping progress:', error);
					}

					// Add alert if there was an error
					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					// Update cart subtotal
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					// Dispatch cart updated event
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {
	window.refreshCart = (preserveTextareaState = false, textareaValue = '', wasFocused = false) => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			// Update header cart counts and totals
			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			});
			
			// Update shipping progress component with new cart total
			const shippingProgress = document.querySelector('shipping-progress');
			if (shippingProgress) {
				const cartTotalElement = cartItems.querySelector('[data-cart-total]');
				if (cartTotalElement) {
					// Extract numeric value from money format (e.g., "€32,50" -> 3250)
					const cartTotalText = cartTotalElement.textContent;
					// Remove currency symbols and convert European format to standard
					const numericValue = cartTotalText
						.replace(/[€$£]/g, '') // Remove currency symbols
						.replace(/\./g, '') // Remove thousands separators (dots in European format)
						.replace(',', '.'); // Replace comma with dot for decimal
					const cartTotal = Math.round(parseFloat(numericValue) * 100);
					// Update shipping progress directly with the cart total
					shippingProgress.updateCartTotal(cartTotal);
				}
			}
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			
			// Preserve textarea state if requested
			if (preserveTextareaState) {
				const textarea = document.getElementById('personal-message-textarea');
				if (textarea && textareaValue !== undefined) {
					textarea.value = textareaValue;
					// Update character count
					const characterCount = document.getElementById('personal-message-character-count');
					if (characterCount) {
						characterCount.textContent = textareaValue.length;
					}
					// Restore focus if it was focused before
					if (wasFocused) {
						setTimeout(() => {
							textarea.focus();
							// Position cursor at the end
							textarea.setSelectionRange(textareaValue.length, textareaValue.length);
						}, 50);
					}
				}
			}
			
			// Show cart drawer if using overlay cart
			if ( document.querySelector('[data-js-site-cart-sidebar]') && KROWN.settings.cart_action == 'overlay' ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

	// Helper function for refreshing cart with textarea state preservation
	window.refreshCartWithTextareaState = (textareaValue, wasFocused) => {
		window.refreshCart(true, textareaValue, wasFocused);
	}

}

// Personal Message Toggle functionality
if ( typeof PersonalMessageToggle !== 'function' ) {
	class PersonalMessageToggle extends HTMLElement {
		constructor() {
			super();
			this.initialized = false;
		}

		connectedCallback() {
			// Wait a bit to ensure cart items are in DOM
			setTimeout(() => {
				if (!this.initialized) {
					this.init();
				}
			}, 100);
		}

		init() {
			this.initialized = true;
			this.toggle = this.querySelector('#personal-message-toggle');
			this.textareaContainer = this.querySelector('#personal-message-textarea-container');
			this.textarea = this.querySelector('#personal-message-textarea');
			this.characterCount = this.querySelector('#personal-message-character-count');
			this.badge = this.querySelector('[data-personal-message-count]');
			this.variantId = this.toggle?.dataset.personalMessageVariantId;

			console.log('Personal message toggle initialized:', {
				toggle: this.toggle,
				textarea: this.textarea,
				variantId: this.variantId
			});

			if (!this.toggle) {
				console.error('Personal message toggle checkbox not found');
				return;
			}

			// Remove any existing listeners to prevent duplicates
			if (this.toggle._changeHandler) {
				this.toggle.removeEventListener('change', this.toggle._changeHandler);
			}
			this.toggle._changeHandler = this.handleToggleChange.bind(this);
			this.toggle.addEventListener('change', this.toggle._changeHandler);

			if (this.textarea) {
				if (this.textarea._inputHandler) {
					this.textarea.removeEventListener('input', this.textarea._inputHandler);
				}
				this.textarea._inputHandler = this.handleTextareaInput.bind(this);
				this.textarea.addEventListener('input', this.textarea._inputHandler);
			}

			// Check if personal message is already in cart
			this.checkExistingPersonalMessage();
		}

		handleToggleChange(event) {
			const isChecked = event.target.checked;
			
			// Clear any pending textarea updates
			if (this.updateTimeout) {
				clearTimeout(this.updateTimeout);
			}
			
			if (isChecked) {
				this.textareaContainer.style.display = 'block';
				this.textarea.focus();
				// Add personal message variant immediately when toggle is checked
				this.addPersonalMessageToCart('');
			} else {
				this.textareaContainer.style.display = 'none';
				this.textarea.value = '';
				this.updateCharacterCount(0);
				this.removePersonalMessageFromCart();
			}
		}

		handleTextareaInput(event) {
			const value = event.target.value;
			const characterCount = value.length;
			
			this.updateCharacterCount(characterCount);
			
			// Debounce the cart update to prevent constant refreshing
			// Clear any existing timeout
			if (this.updateTimeout) {
				clearTimeout(this.updateTimeout);
			}
			
			// Only update the message if the personal message item already exists in cart
			// Don't add new items on every keystroke
			if (this.hasPersonalMessageInCart()) {
				// Set a timeout to update the cart after user stops typing
				this.updateTimeout = setTimeout(() => {
					this.updatePersonalMessageInCart(value);
				}, 1000); // Wait 1 second after user stops typing
			}
		}

		updateCharacterCount(count) {
			if (this.characterCount) {
				this.characterCount.textContent = count;
			}
		}

		async addPersonalMessageToCart(message) {
			if (!this.variantId) {
				console.error('No variant ID found for personal message');
				return;
			}

			console.log('Adding personal message to cart:', { variantId: this.variantId, message });

			try {
				// Create form data like the product form does
				const formData = new FormData();
				formData.append('id', this.variantId);
				formData.append('quantity', '1');
				if (message) {
					formData.append('properties[Personal Message]', message);
				}

				console.log('Cart add request form data:', Object.fromEntries(formData));

				const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
					method: 'POST',
					headers: {
						'X-Requested-With': 'XMLHttpRequest'
					},
					body: formData
				});

				console.log('Cart add response status:', response.status);

				if (response.ok) {
					const responseData = await response.json();
					console.log('Cart add response data:', responseData);
					this.updateBadge(1);
					// Refresh cart to show the new item, preserving textarea state
					if (window.refreshCart) {
						window.refreshCartWithTextareaState(this.textarea.value, this.textarea === document.activeElement);
					}
				} else {
					const errorData = await response.text();
					console.error('Cart add failed:', response.status, errorData);
				}
			} catch (error) {
				console.error('Error adding personal message to cart:', error);
			}
		}

		async removePersonalMessageFromCart() {
			if (!this.variantId) return;

			try {
				// Find the personal message item in cart and remove it
				const cartItems = document.querySelectorAll('[data-js-cart-item]');
				let personalMessageLine = null;

				cartItems.forEach(item => {
					const productId = item.dataset.productId;
					// You might need to adjust this logic based on how you identify the personal message product
					if (productId && item.querySelector('.cart-item__title')?.textContent.includes('Persoonlijk bericht')) {
						personalMessageLine = item.dataset.line;
					}
				});

				if (personalMessageLine) {
					console.log('Removing personal message from cart, line:', personalMessageLine);

					const response = await fetch(KROWN.settings.routes.cart_change_url, {
						method: 'POST',
						headers: { 
							'Content-Type': 'application/json', 
							'Accept': 'application/javascript' 
						},
						body: JSON.stringify({
							line: parseInt(personalMessageLine),
							quantity: 0
						})
					});

					if (response.ok) {
						this.updateBadge(0);
						// Refresh cart to update the display, preserving textarea state
						if (window.refreshCart) {
							window.refreshCartWithTextareaState(this.textarea.value, this.textarea === document.activeElement);
						}
					} else {
						console.error('Failed to remove personal message from cart');
					}
				} else {
					console.log('No personal message found in cart to remove');
				}
			} catch (error) {
				console.error('Error removing personal message from cart:', error);
			}
		}

		updateBadge(count) {
			if (this.badge) {
				this.badge.textContent = count;
				this.badge.dataset.personalMessageCount = count;
			}
		}

		checkExistingPersonalMessage() {
			// Check if personal message is already in cart and update UI accordingly
			const cartItems = document.querySelectorAll('[data-js-cart-item]');
			let hasPersonalMessage = false;
			let personalMessageText = '';

			cartItems.forEach(item => {
				const title = item.querySelector('.cart-item__title')?.textContent;
				if (title && title.includes('Persoonlijk bericht')) {
					hasPersonalMessage = true;
					// Try to get the message from properties
					const properties = item.querySelectorAll('.cart-item__property');
					properties.forEach(prop => {
						if (prop.textContent.includes('Personal Message:')) {
							personalMessageText = prop.textContent.replace('Personal Message:', '').trim();
						}
					});
				}
			});

			if (hasPersonalMessage) {
				this.toggle.checked = true;
				this.textareaContainer.style.display = 'block';
				this.textarea.value = personalMessageText;
				this.updateCharacterCount(personalMessageText.length);
				this.updateBadge(1);
			}
		}

		hasPersonalMessageInCart() {
			const cartItems = document.querySelectorAll('[data-js-cart-item]');
			for (let item of cartItems) {
				const title = item.querySelector('.cart-item__title')?.textContent;
				if (title && title.includes('Persoonlijk bericht')) {
					return true;
				}
			}
			return false;
		}

		async updatePersonalMessageInCart(message) {
			// Find the personal message item and update its properties
			const cartItems = document.querySelectorAll('[data-js-cart-item]');
			let personalMessageLine = null;

			cartItems.forEach(item => {
				const title = item.querySelector('.cart-item__title')?.textContent;
				if (title && title.includes('Persoonlijk bericht')) {
					personalMessageLine = item.dataset.line;
				}
			});

			if (personalMessageLine) {
				try {
					console.log('Updating personal message in cart, line:', personalMessageLine, 'message:', message);

					const response = await fetch(KROWN.settings.routes.cart_change_url, {
						method: 'POST',
						headers: { 
							'Content-Type': 'application/json', 
							'Accept': 'application/javascript' 
						},
						body: JSON.stringify({
							id: this.variantId,
							quantity: 1,
							properties: {
								'Personal Message': message
							}
						})
					});

					if (response.ok) {
						console.log('Personal message updated successfully');
						// Refresh cart to show the updated message, but preserve textarea state
						if (window.refreshCart) {
							window.refreshCartWithTextareaState(this.textarea.value, this.textarea === document.activeElement);
						}
					} else {
						console.error('Failed to update personal message in cart');
					}
				} catch (error) {
					console.error('Error updating personal message in cart:', error);
				}
			}
		}
	}

	if ( typeof customElements.get('personal-message-toggle') == 'undefined' ) {
		customElements.define('personal-message-toggle', PersonalMessageToggle);
	}
}